

export const AppComponent: ng.IComponentOptions = {
  template: `
      <div ui-view id="multiContent" ng-class="{ 'disable-selection' : disableTextSelectionOnPage === true }" name="multiContent" class="full-height">
      </div>
      <env-ribbon></env-ribbon>
    `
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/app.component.ts